import * as React from 'react'
import { TaskFileFieldConnected } from './TaskFileFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TaskFileFieldExamples = () => {
  return (
    <div className="TaskFileFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskFileFieldConnected taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
